/* eslint-disable @typescript-eslint/no-explicit-any */
// import CustomButton from '@/components/ui/customButton';
import { Input } from '@/components/ui/input';
import { Button, DeleteModal, EscalationRejectionModal, NextDocumentModal } from 'fluent-components';
import DocumentReviewButton from '@/components/ui/DocumentReviewButton';
import React, { useState, useEffect, useMemo, useRef } from 'react';
import approvedIcon from '@/assets/approvedIcon.svg';
import { fhirAPI } from '@/lib/axios';
import {
  createBundleForApproved,
  createBundleForRejected,
  createBundleForEscalated,
  createBundleForWorkflowCompleted,
} from './fhirTaskBundle';
import { getPractitionerId, getDocumentStatus, isNewDay, removeNullAndEmptyObjects, removeTypeName, formatTime, clearAllObservationsFromLocalStorage, buildLonicESQuery } from '@/lib/utils';
import { ESCALATION_AND_REJECTED_QUERY } from '@/graphql/queries/record-management';
import { toast } from '@/components/hooks/use-toast';
import { useNavigate } from 'react-router-dom';
import deleteIcon from '../../../assets/deleteIcon.svg';
import {newPermissionsFeatureCodes, RECORD_VALUESET_URLS } from '@/constants';
import useUserInfo from '@/components/Authenticate/useUserInfo';
import { documentReferenceAPIs } from '@/lib/axios/apis/recordManagement/document';
import { Concept } from '@/pages/AddEditDoctor/components/types';
import { SearchableInput } from '@/components/common/SearchableInput';
import { debounce } from 'lodash';
import { useQuery } from '@apollo/client';
import { eventBus } from "../../../eventBus";
import { mixPanelServiceInstance } from '@/analytics/mixpanel';
import { mixPanelEvents } from '@/analytics/mixpanel/events';
import { getLonicSuggestion } from '@/lib/elasticSearch';

interface ValidateFormProps {
  data: Task;
  isSupervisor?: boolean;
  description?: string;
}

interface Parameter {
  system: string;
  code: string;
  display: string;
}
interface LabRecord {
  id: number;
  parameter: Parameter;
  value: string;
  lowerRange: string;
  upperRange: string;
  unit: string;
  approved: boolean;
  effectiveDateTime: string;
}
interface Identifier {
  value: string;
}

interface Meta {
  lastUpdated?: string;
  tag?: Coding[];
}

interface Coding {
  code: string;
  display?: string | null;
  system?: string | null;
}

interface CodeableConcept {
  coding: Coding[];
}

interface HumanName {
  family: string;
  prefix?: string | null;
  given: string[];
  use?: string | null;
}

interface Patient {
  id: string;
  name: HumanName[];
}

interface Reference {
  reference: string;
  resource?: any; // Use specific types if needed, e.g., `Patient | DocumentReference`
}

interface Attachment {
  url: string;
  size: number;
  title: string;
  creation?: string | null;
  contentType: string;
  data ?: string | null;
  hash?: string | null;
}

interface DocumentReferenceContent {
  attachment: Attachment;
}

interface DocumentReferenceContext {
  related: Reference[];
  period: {
    start: string;
    end: string;
  };
}

interface DocumentReference {
  id: string;
  type?: any | null;
  description?: string;
  status: string;
  docStatus: string;
  subject: Reference;
  content: DocumentReferenceContent[];
  context?: DocumentReferenceContext;
  meta?: Meta;
}

interface Task {
  owner: any;
  id: string;
  identifier: Identifier[];
  meta: Meta;
  businessStatus: CodeableConcept;
  intent: string;
  status: string;
  for: Reference & { resource: Patient };
  focus: Reference & { resource: DocumentReference };
  output: any[];
}

type DocumentReviewOptions = 'Approve' | 'Reject' | 'Escalate';

enum PermissionType {
  Approve = 'Approve',
  Reject = 'Reject',
  Escalate = 'Escalate',
}

const initialParameterState: LabRecord[] = [
  {
    id: 1,
    parameter: { system: '', code: '', display: '' },
    value: '',
    lowerRange: '',
    upperRange: '',
    // referenceRange: [],
    unit: '',
    approved: false,
    effectiveDateTime: '',
  },
];

const ValidateForm: React.FC<ValidateFormProps> = (
  taskOP: ValidateFormProps,
) => {
  const { data: taskDetails , isSupervisor, description} = taskOP;
  const navigate = useNavigate();

  const { data: escalateRejectedList} =
      useQuery<any>(ESCALATION_AND_REJECTED_QUERY);
  const {documentEscalationReasons, documentRejectionReasons, documentLegalEscalationReasons } = escalateRejectedList || {};
  const rejectionReason = documentRejectionReasons?.[0]?.compose?.include?.[0]?.concept?.map((reason: any) => ({ label: reason.display, value: reason.code })) || [];
  const escalateReason = documentEscalationReasons?.[0]?.compose?.include?.[0]?.concept?.map((reason: any) => ({ label: reason.display, value: reason.code })) || [];
  const legalEscalationReason = documentLegalEscalationReasons?.[0]?.compose?.include?.[0]?.concept?.map((reason: any) => ({ label: reason.display, value: reason.code })) || [];
  const [observations, setObservations] = useState<LabRecord[]>(
    initialParameterState
  );
  const [initalParameter, setInitalParameter] = useState<any[]>();
  const [searchParameter, setSearchParameter] = useState<string>('');
  const [allParameterUnits, setAllParameterUnits] = useState<string[]>([]);
  const [parameterUnits, setParametersUnits] = useState<string[]>([]); 
  const [invalidObservations, setInvalidObservations] = useState<number[]>([]);
  const [type, setType] = useState<string>('');
  const [totalObservationsIteracted, setTotalObservationsInteracted] = useState<number>(0);
  const [showNextDocumentModal, setShowNextDocumentModal] =
      useState<boolean>(false);
  
  const [listOfParameters, setListOfParameters] = useState<
    { value: string; label: string }[]
  >([]);

  const [showDeleteModal, setShowDeleteModal] =
      useState<boolean>(false);
    const [removeObservationId, setRemoveObservationId] = useState<number>()
  const { userInfo } = useUserInfo();

  const patientReference = taskDetails?.for?.reference ?? '';
  const documentRef = taskDetails?.focus?.resource;
  const documentPeriod = documentRef?.context?.period?.end; 
  const practitionerReference = getPractitionerId(userInfo) ?? '';
  const performerReference = getPractitionerId(userInfo) ?? '';
  const { userPermissions } = useUserInfo();
  const [addedObservationCount, setAddObservationCount] = useState<number>(0);
  const [deletedObservationCount, setDeletedObservationCount] = useState<number>(0);
  const [updatedObservationCount, setUpdatedObservationCount] = useState<number>(0);
  const [effectiveDateTime, setEffectiveDateTime] = useState<string>('');
  const [disableOnsubmit, setDisableOnSubmit] = useState<boolean>(false);
  const updatedIdsRef = useRef<Set<number>>(new Set());
  const addRow = () => {
    setObservations((prev) => [
      ...prev,
      {
        id: prev.length + 1,
        parameter: { system: '', code: '', display: '' },
        value: '',
        lowerRange: '',
        upperRange: '',
        unit: '',
        approved: false,
        effectiveDateTime: effectiveDateTime
      },
    ]);
    setAddObservationCount(addedObservationCount + 1);
    setTotalObservationsInteracted(totalObservationsIteracted + 1);
  };


  // Note: add splice to remove the row
  const removeRow = (id?: number) => {
    setShowDeleteModal(false);
    setObservations((prev) => prev.filter((item) => item.id !== id));
    setDeletedObservationCount((prev) => prev + 1);
    setTotalObservationsInteracted((prev) => prev + 1);
  
    // Remove from localStorage if approved version exists
    const key = `observationsFor${taskDetails?.id}`;
    const raw = localStorage.getItem(key);
    if (raw && id !== undefined) {
      const data: LabRecord[] = JSON.parse(raw);
      const filtered = data.filter((item) => item.id !== id);
      localStorage.setItem(key, JSON.stringify(filtered));
    }
  };
  

  const onRemoveRow = (id: number) => {
    setShowDeleteModal(true)
    setRemoveObservationId(id)
  }

  // Modal states for rejection and escalation
  const [isRejectionModalOpen, setIsRejectionModalOpen] =
    useState<boolean>(false);
  const [isEscalationModalOpen, setIsEscalationModalOpen] =
    useState<boolean>(false);

  const openRejectionModal = () => {
    const hasPermission =
      userPermissions?.[newPermissionsFeatureCodes.validator_documents_reject] ===
      'CHECK_RESULT_ALLOWED';
    if (hasPermission) {
      setIsRejectionModalOpen(true);
    } else {
      toast({
        title: 'Warning',
        description: `You don't have access!`,
        variant: 'destructive',
      });
    }
  };

  const handleChange = (id: number, field: string, value: string | boolean | Parameter) => {
    const localKey = `observationsFor${taskDetails?.id}`;
  
    setObservations((prev) => {
      const updated = prev.map((item) => {
        if (item.id !== id) return item;
  
        const updatedItem = { ...item };
  
        // Field-specific logic
        if (field === 'parameter' && typeof value === 'object' && value !== null) {
          updatedItem.parameter = value;
          updatedItem.approved = false; // editing = revoke approval
        } else if (field === 'unit') {
          updatedItem.unit = value as string;
          updatedItem.approved = false;
        } else if (field === 'approved') {
          updatedItem.approved = Boolean(value);
        } else {
          (updatedItem as any)[field] = value;
          updatedItem.approved = false;
        }
  
        return updatedItem;
      });
  
      // LocalStorage sync logic only for 'approved' field
      const changedItem = updated.find((item) => item.id === id);
      if (changedItem && field === 'approved') {
        const raw = localStorage.getItem(localKey);
        const saved = raw ? JSON.parse(raw) : [];
  
        if (changedItem.approved) {
          // Add or update approved item
          const filtered = saved.filter((obs: any) => obs.id !== id);
          localStorage.setItem(localKey, JSON.stringify([...filtered, changedItem]));
        } else {
          // Remove from localStorage
          const filtered = saved.filter((obs: any) => obs.id !== id);
          localStorage.setItem(localKey, JSON.stringify(filtered));
        }
      } else if (changedItem && changedItem.approved === false) {
        // If editing any field (not 'approved') after approval, remove from localStorage
        const raw = localStorage.getItem(localKey);
        const saved = raw ? JSON.parse(raw) : [];
        const filtered = saved.filter((obs: any) => obs.id !== id);
        localStorage.setItem(localKey, JSON.stringify(filtered));
      }
      return updated;
    });
  
    // Track updates
    if (!updatedIdsRef.current.has(id)) {
      updatedIdsRef.current.add(id);
      setUpdatedObservationCount((prev) => prev + 1);
    }
  
    // Searchable dropdown updates
    if (field === 'parameter' || field === 'unit') {
      setSearchParameter(value as string);
    }
  
    if (field === 'unit' && typeof value === 'string') {
      setParametersUnits(
        value === ''
          ? allParameterUnits
          : allParameterUnits.filter((unit) =>
              unit.toLowerCase().includes(value.toLowerCase())
            )
      );
    }
  };
  

  const handleChangeParameter = (id: number, value: Parameter) => {
    setSearchParameter(value.display); // Show selected label in input
    setObservations((prev) =>
      prev.map((item) =>
        item.id === id ? { ...item, parameter: value } : item
      )
    );
    handleChange(id, 'approved', false);
  };


  const openEscalationModal = () => {
    const hasPermission =
      userPermissions?.[newPermissionsFeatureCodes.validator_documents_escalate] ===
      'CHECK_RESULT_ALLOWED';
    if (hasPermission) {
      setIsEscalationModalOpen(true);
    } else {
      toast({
        title: 'Warning',
        description: `You don't have access!`,
        variant: 'destructive',
      });
    }
  };

  useEffect(() => {
    let isMounted = true;
  
    documentReferenceAPIs
      .getAllValueSet(RECORD_VALUESET_URLS.PARAMETER_UNITS) 
      .then((res) => {
        const valueSet = res?.map((item: Concept) => ({
          value: item.code,
          label: item.display,
        }));
  
        const valuesOnly = valueSet.map((item: { value: string }) => item.value);
  
        if (
          isMounted &&
          JSON.stringify(valuesOnly) !== JSON.stringify(allParameterUnits)
        ) {
          setAllParameterUnits(valuesOnly);
          setParametersUnits(valuesOnly);
        }
      });
  
    return () => {
      isMounted = false;
    };
  }, []);

useEffect(() => {
  const localKey = `observationsFor${taskDetails?.id}`;

  try {
    // Check if localStorage already has approved observations
    const stored = localStorage.getItem(localKey);
    if (stored) {
      const savedObservations = JSON.parse(stored);
      setObservations(savedObservations);
      setTotalObservationsInteracted(savedObservations.length);
      setEffectiveDateTime(documentPeriod);
      return;
    }

    // If not in localStorage, fall back to parsing from documentRef
    const labReportContent = documentRef.content.find(
      (content: any) => content.attachment?.title === 'Lab Report Extraction'
    );
    if(!labReportContent?.attachment?.data) return;
    const bundleData = { value: labReportContent?.attachment?.data };

    const binaryData = Uint8Array.from(atob(bundleData.value), (c) => c.charCodeAt(0));
    const decodedData = new TextDecoder().decode(binaryData);

    if (!decodedData.trim().startsWith("{") && !decodedData.trim().startsWith("[")) {
      throw new Error("Decoded data is not valid JSON.");
    }

    const bundle = JSON.parse(decodedData);
    setInitalParameter(bundle.entry || []);
    setTotalObservationsInteracted(bundle.entry?.length || 0);
    setEffectiveDateTime(documentPeriod);

    if (!bundle?.entry) {
      console.warn("No entries found in parsed bundle.");
      toast({
        title: "Empty Bundle",
        description: "No entries found in parsed bundle.",
        variant: "default",
      });
      return;
    }

    const extractedData: LabRecord[] = bundle.entry.map((item: any, index: number) => ({
      id: index + 1,
      parameter: {
        system: 'http://loinc.org',
        code: item?.resource?.code?.coding?.[0]?.code || item?.code?.coding?.[0]?.code || "",
        display: item?.resource?.code?.text || item?.code?.text || ""
      },
      value: item?.resource?.valueString || item?.resource?.valueQuantity?.value ||
             item?.valueString || item?.valueQuantity?.value || null,
      lowerRange: item?.resource?.referenceRange?.[0]?.low?.value || item?.referenceRange?.[0]?.low?.value || null,
      upperRange: item?.resource?.referenceRange?.[0]?.high?.value || item?.referenceRange?.[0]?.high?.value || null,
      unit: item?.resource?.valueQuantity?.unit || item?.valueQuantity?.unit || "",
      approved: false,
    }));

    setObservations(extractedData);
  } catch (error) {
    console.error("Error decoding or parsing document reference data:", error);
  }
}, [documentRef, taskDetails?.id]);


  useEffect(() => {
    if (
      !localStorage.getItem('validationStarted') &&
      observations.length > 0 &&
      initalParameter
    ) {
      localStorage.setItem('validationStarted', 'true');
      if (isSupervisor) {
        mixPanelServiceInstance.track(mixPanelEvents.RECORD_MANAGEMENT.ESCALATED_DOCUMENT_VALIDATION_STARTED, {
          document_id: taskDetails?.focus?.reference?.split('/')?.[1],
          supervisor_id: taskDetails?.for?.reference?.split('/')?.[1],
        });
      } else {
        mixPanelServiceInstance.track(mixPanelEvents.RECORD_MANAGEMENT.DOCUMENT_VALIDATION_STARTED, {
          document_id: taskDetails?.focus?.reference?.split('/')?.[1],
          validator_id: taskDetails?.owner?.reference?.split('/')?.[1],
          dv_initial_parameter_count: initalParameter.length,
          dv_initial_parameter_list: initalParameter.map((item) => item?.code?.text).join(','),
          dv_document_type: "lab_report",
        });
      }
    }
  }, [observations, initalParameter]);
  

  const debouncedSearch = useMemo(
    () =>
      debounce(async (query: string) => {
        if (!query) {
          setListOfParameters([]);
          return;
        }
        try {
          const esQuery = buildLonicESQuery(query);
          // Todo: Elastic might be removed later
          // const response = await documentReferenceAPIs.getAllValueSetForTaxonomy(RECORD_VALUESET_URLS.LOINC_VALUESET_URL, query);
          const response = await getLonicSuggestion(esQuery);
          const results = response?.data?.hits?.hits?.map((item: any) => {
          const source = item._source;
          // Just return the source without trying to handle highlights
          return source;
          }) || [];
          if (Array.isArray(results)) {
            setListOfParameters(results?.map((item: { LOINC_NUM: string, LONG_COMMON_NAME: string }) => ({ value: item.LOINC_NUM, label: item.LONG_COMMON_NAME })));
          }
        } catch (error) {
          console.error('API Error:', error);
        }
      }, 700),
    []
  );

  useEffect(() => {
    debouncedSearch(searchParameter);
    return () => {
      debouncedSearch.cancel();
    };
  }, [searchParameter, debouncedSearch]);

  const handlePause = async () => {
    navigate('/validate-paused');
  };

  const submitDocument = async (type: DocumentReviewOptions, data?: any) => {
    const timer = localStorage.getItem('timer') || 0;
    setDisableOnSubmit(true);
    const permissionMap: Record<PermissionType, string> = {
      [PermissionType.Approve]: newPermissionsFeatureCodes.validator_documents_approve,
      [PermissionType.Reject]: newPermissionsFeatureCodes.validator_documents_reject,
      [PermissionType.Escalate]: newPermissionsFeatureCodes.validator_documents_escalate,
    };
    setType(type);

    const storedData = JSON.parse(localStorage.getItem("documentCount") || "{}");
    const today = new Date().toISOString().split("T")[0];
    let newCount = 1;
    if (!isNewDay()) {
        newCount = storedData.count + 1;
    }

    localStorage.setItem("documentCount", JSON.stringify({ date: today, count: newCount }));

    const hasPermission = (
      type: PermissionType,
      userPermissions: Record<string, string>
    ): boolean => {
      return (
        userPermissions?.[permissionMap[type]] === 'CHECK_RESULT_ALLOWED' ||
        false
      );
    };
    if (
      hasPermission(PermissionType.Approve, userPermissions) &&
      type === 'Approve'
    ) {
      const invalidFields = observations
      .filter(
        (item) =>
          !item?.parameter?.display || Number(item?.parameter?.code) === 0 ||
          item?.value?.length === 0 || // Allows 0 but filters out null & undefined
          item?.approved === false
      )
      .map((item) => item?.parameter?.display || 'Unnamed Parameter');
      if (invalidFields.length > 0) {
        setInvalidObservations(
          observations
            .filter((obs) => !obs.parameter?.display || Number(obs?.parameter?.code) === 0 || !obs.value || obs.approved === false)
            .map((obs) => obs.id)
        );
        toast({
          title: 'Incomplete Validation',
          description: 'You have not checked all the parameters',
          variant: 'destructive',
        });
        setDisableOnSubmit(false);
        return;
      }
      if (observations?.length > 0) {
        try {

          const bundleForApproved: any[] = createBundleForApproved(
            observations.map((obs) => ({
              ...obs,
              effectiveDateTime: obs.effectiveDateTime || "",
            })),
            patientReference,
            performerReference,
            `Practitioner/${practitionerReference}`,
            taskDetails,
            isSupervisor,
            `${userInfo?.firstName} ${userInfo?.lastName}`,
          );
          const fhirBundleForApproved = {
            resourceType: 'Bundle',
            type: 'transaction',
            entry: bundleForApproved,
          };
          await fhirAPI.post('', removeNullAndEmptyObjects(removeTypeName(fhirBundleForApproved)));
          toast({
            title: 'Success',
            description: 'Document updated successfully',
            variant: 'default',
          });
        } catch (error: any) {
          toast({
            title: `Error ${error.status}`,
            description: 'Document update failed',
            variant: 'destructive',
          });
        } finally {
          eventBus.emit("resetTimer");
          const taskBundle = {
            resourceType: 'Bundle',
            type: 'transaction',
            entry: createBundleForWorkflowCompleted(taskDetails, "completed"),
          };
          await fhirAPI.post('', removeNullAndEmptyObjects(removeTypeName(taskBundle)));
          if (!isSupervisor) {
            mixPanelServiceInstance.track(mixPanelEvents.RECORD_MANAGEMENT.DOCUMENT_VALIDATION_COMPLETED, {
              document_id: taskDetails?.focus?.reference,
              dv_status: 'approved',
              dv_parameter_added_count: addedObservationCount,
              dv_parameter_deleted_count: deletedObservationCount,
              dv_final_parameter_count: observations?.length,
              dv_final_parameter_list: observations?.map((item) => item.parameter.display).join(','),
              dv_total_parameter_interacted : totalObservationsIteracted,
              dv_validation_time: formatTime(Number(timer) || 0),
              dv_document_type: "lab_report",
              validator_id: taskDetails?.for?.reference?.split('/')?.[1],
            });
            setShowNextDocumentModal(true);
            clearAllObservationsFromLocalStorage();
            localStorage.removeItem('validationStarted');
          } else {
            mixPanelServiceInstance.track(mixPanelEvents.RECORD_MANAGEMENT.ESCALATED_DOCUMENT_VALIDATION_COMPLETED, {
              // Todo: Add properties
              document_id: taskDetails?.focus?.reference?.split('/')?.[1],
              edv_status: type,
              edv_type_of_document: 'lab_report',
              edv_escalation_reason: taskDetails?.output?.[0]?.type?.coding?.[0]?.display,
              supervisor_id: taskDetails?.owner?.reference?.split('/')?.[1],
            })
            setDisableOnSubmit(false);
            navigate('/supervisor');
          }
        }
      } else {
        toast({
          title: `Enter atleast one parameter needed to approve`,
          variant: 'destructive',
        });
        setDisableOnSubmit(false);
      }
    } else if (
      hasPermission(PermissionType.Reject, userPermissions) &&
      type === 'Reject'
    ) {
      try {
        const bundleForRejected = createBundleForRejected(
          patientReference,
          `Practitioner/${practitionerReference}`,
          taskDetails,
          data,
          isSupervisor,
          `${userInfo?.firstName} ${userInfo?.lastName}`,
        );
        const fhirBundleForRejected = {
          resourceType: 'Bundle',
          type: 'transaction',
          entry: bundleForRejected,
        };

        await fhirAPI.post("", removeNullAndEmptyObjects(removeTypeName(fhirBundleForRejected)));
        if (!isSupervisor) {
          setShowNextDocumentModal(true);
          localStorage.removeItem('validationStarted');
        } else {
          navigate('/supervisor');
        }

      } catch (error: any) {
        toast({
          title: `Error ${error.status}`,
          description: 'Document update failed',
          variant: 'destructive',
        });
      } finally {
        eventBus.emit("resetTimer");
        const taskBundle = {
          resourceType: 'Bundle',
          type: 'transaction',
          entry: createBundleForWorkflowCompleted(taskDetails, "rejected"),
        };
        await fhirAPI.post('', removeNullAndEmptyObjects(removeTypeName(taskBundle)));
        if (!isSupervisor) {
          setShowNextDocumentModal(true);
          localStorage.removeItem('validationStarted');
          // Two events are being tracked here, one for the document validation completed and another for the document rejected.
          mixPanelServiceInstance.track(mixPanelEvents.RECORD_MANAGEMENT.DOCUMENT_VALIDATION_COMPLETED, {
            document_id: taskDetails?.focus?.reference,
            dv_status: 'approved',
            dv_parameter_added_count: observations?.length,
            dv_parameter_deleted_count: deletedObservationCount,
            dv_parameter_updated_count: updatedObservationCount,
            dv_final_parameter_count: observations?.length,
            dv_final_parameter_list: observations?.map((item) => item.parameter.display).join(','),
            dv_total_parameter_interacted : updatedObservationCount,
            dv_validation_time: localStorage.getItem('timer'),
            dv_document_type: "lab_report",
            validator_id: taskDetails?.for?.reference?.split('/')?.[1],
          });
          mixPanelServiceInstance.track(mixPanelEvents.RECORD_MANAGEMENT.DOCUMENT_REJECTED, {
            document_id: taskDetails?.focus?.reference?.split('/')?.[1],
            rejector_id: taskDetails?.owner?.reference?.split('/')?.[1],
            rejectionReason: data,
            rejection_note: data,
            rejector_role: 'Validator',
            rejection_stage: 'document_validation',
          });
          mixPanelServiceInstance.track(mixPanelEvents.RECORD_MANAGEMENT.ESCALATED_DOCUMENT_VALIDATION_COMPLETED, {
            // Todo: Add properties
            document_id: taskDetails?.focus?.reference?.split('/')?.[1],
            edv_status: taskDetails?.businessStatus?.coding[0]?.code,
            edv_name_on_document: taskDetails?.focus?.resource?.description,
            edv_type_of_document: 'lab_report',
            edv_escalation_reason: data,
            supervisor_id: taskDetails?.owner?.reference?.split('/')?.[1],
          })
          setDisableOnSubmit(false);
        } else {          
          navigate('/supervisor');
        }
      }
    } else if (
      hasPermission(PermissionType.Escalate, userPermissions) &&
      type === 'Escalate'
    ) {
      try {
        const bundleForEscalated = createBundleForEscalated(
          patientReference,
          `Practitioner/${practitionerReference}`,
          taskDetails,
          data,
          isSupervisor,
          `${userInfo?.firstName} ${userInfo?.lastName}`,
        );
        const fhirBundleForEscalated = {
          resourceType: 'Bundle',
          type: 'transaction',
          entry: bundleForEscalated,
        };
        await fhirAPI.post("", removeNullAndEmptyObjects(removeTypeName(fhirBundleForEscalated)));
        if (!isSupervisor) {
          setShowNextDocumentModal(true);
          localStorage.removeItem('validationStarted');
        } else {
          // two events are being tracked here, one for the document validation completed and another for the document escalated.
          mixPanelServiceInstance.track(mixPanelEvents.RECORD_MANAGEMENT.DOCUMENT_VALIDATION_COMPLETED, {
            document_id: taskDetails?.focus?.reference,
            dv_status: 'approved',
            dv_parameter_added_count: observations?.length,
            dv_parameter_deleted_count: deletedObservationCount,
            dv_parameter_updated_count: updatedObservationCount,
            dv_final_parameter_count: observations?.length,
            dv_final_parameter_list: observations?.map((item) => item.parameter.display).join(','),
            dv_total_parameter_interacted : updatedObservationCount,
            dv_validation_time: localStorage.getItem('timer'),
            dv_document_type: "lab_report",
            validator_id: taskDetails?.for?.reference?.split('/')?.[1],
          });
          setDisableOnSubmit(false);
          navigate('/supervisor');
        }
      } catch (error: any) {  

        toast({
          title: `Error ${error.status}`,
          description: 'Document update failed',
          variant: 'destructive',
        });
      } finally {
        mixPanelServiceInstance.track(mixPanelEvents.RECORD_MANAGEMENT.DOCUMENT_ESCALATED, {
          document_id: documentRef?.id || '',
          escalator_id: taskDetails?.owner?.reference?.split('/')?.[1],
          escalation_reason: data.reason,
          escalation_notes: data.description,
          escalator_role: isSupervisor ? 'supervisor' : 'validator',
          escalation_stage:  'document validation'
        })
        setDisableOnSubmit(false);
      }
    } else {
      toast({
        title: 'Warning',
        description: `You don't have access!`,
        variant: 'destructive',
      });
    }
  };
  
  const mergedObservations = useMemo(() => {
    const key = `observationsFor${taskDetails?.id}`;
    const localApprovedRaw = localStorage.getItem(key);
    const localApproved = localApprovedRaw ? JSON.parse(localApprovedRaw) : [];
  
    const localApprovedIds = new Set(localApproved.map((obs: LabRecord) => obs.id));
    const remainingObservations = observations.filter(
      (obs) => !localApprovedIds.has(obs.id)
    );
    return [...localApproved, ...remainingObservations];
  }, [observations, taskDetails?.id]);
  return (
    <>
      <div className="bg-[#FCFCFF]-500 rounded-sm shadow-sm border border-[#DADCFF] h-[70%] overflow-y-auto relative">
      {description && (
        <>
        <div className="flex flex-col gap-2 mb-5 p-5">
          <label className="block text-sm font-medium border-[#CED1D2] text-gray-700">
            Issue description (raised by validator)
          </label>
          <div className=" border rounded-md border-[#DADCFF] bg-[#F3F3F4] p-2">
            <p className="text-sm break-words overflow-wrap break-word text-[#5B5D5F]">{description}</p>
          </div>
        </div>
        </>
      )}
        <p className="text-[#14181A] text-lg font-medium px-6 py-8">
          Lab Report Parameters
        </p>

        <div className="w-full">
          <div className="flex bg-gray-10 text-charcoal-100 text-sm font-normal flex-nowrap pr-6 pl-3">
            <div className="flex-none py-3 text-center pr-1 w-[5%]">S.no</div>
            <div className="flex-none py-3 text-center pr-1 w-[28%]">
              Parameter
            </div>
            <div className="flex-none py-3 text-center pr-1 w-[14%]">
              LOINC
            </div>
            <div className="flex-none py-3 text-center pr-1 w-[11%]">Value</div>
            <div className="flex-none py-3 text-center pr-1 w-[11%]">Lower</div>
            <div className="flex-none py-3 text-center pr-1 w-[11%]">Upper</div>
            <div className="flex-none text-right py-3 pr-1 w-[9%]">Unit</div>
            {/* <div className="flex-none py-3 text-center pr-1 w-[15%]">
              Accuracy
            </div> */}
            <div className="flex-none py-3 text-right pr-1 w-[12%]">Action</div>
          </div>
          {mergedObservations?.map((data, index) => (
            <div className="flex flex-col"  key={data.id}>
              <div className="flex m-1 rounded-lg"  key={data.id} style={{
              backgroundColor: invalidObservations.includes(data.id) ? '#cf0a0a14' : 'white',
            }}>
                <div className="flex text-center px-1 py-2 flex-nowrap">
                  <div className="flex-none pl-4 pr-8 w-[3%] self-center">
                    {index + 1}
                  </div>
                  <div className="flex-none pr-2 w-[28%]">
                    <SearchableInput
                      value={data?.parameter?.display}
                      onChange={(e) =>
                        handleChange(data.id, 'parameter', e.target.value)
                      }
                      onOptionSelect={(selectedOption) =>
                        handleChangeParameter(data.id, {
                          system: 'http://loinc.org',
                          code: selectedOption.value,
                          display: selectedOption.label,
                        })
                      } // Passes full object
                      options={listOfParameters}
                      dropdownPosition="left"
                      width="500px"
                      displayDescription={true}
                      title={data?.parameter?.display}
                    />
                    
                  </div>
                  <div className='flex-none pr-2 w-[14%]'>
                  <Input value={data?.parameter?.code} disabled/>
                  </div>
                  <div className="flex-none pr-2 w-[10%]">
                    <Input
                      value={data.value}
                      onChange={(e) =>
                        handleChange(data.id, 'value', e.target.value)
                      }
                      title={data?.value}
                    />
                  </div>
                  <div className="flex-none pr-2 w-[10%]">
                    <Input
                      value={data.lowerRange}
                      onChange={(e) =>
                        handleChange(data.id, 'lowerRange', e.target.value)
                      }
                      title={data?.referenceRange?.[0]?.low?.value}
                    />
                  </div>
                  <div className="flex-none pr-2 w-[10%]">
                    <Input
                      value={data.upperRange}
                      onChange={(e) =>
                        handleChange(data.id, 'upperRange', e.target.value)
                      }
                      title={data?.upperRange}
                    />
                  </div>
                  <div className="flex-none pr-2 w-[13%]">
                    <SearchableInput
                      value={data.unit}
                      onChange={(e) =>
                        handleChange(data.id, 'unit', e.target.value)
                      }
                      onOptionSelect={(selectedOption) =>
                        handleChange(data.id, 'unit', selectedOption.value)
                      }
                      options={parameterUnits.map((unit) => ({
                        value: unit,
                        label: unit,
                      }))}
                      dropdownPosition="right"
                      width="200px"
                      displayDescription={false}
                      title={data?.unit}
                    />
                  </div>
                  <div className="flex py-1 pl-1 w-[8%] cursor-pointer">
                    <input
                      className="h-4 w-4 m-auto accent-[#002B4E] rounded-full"
                      type="checkbox"
                      alt="Checkbox"
                      checked={data.approved}
                      onChange={(e) =>
                        handleChange(data.id, 'approved', e.target.checked)
                      }
                    />
                  </div>
                  <div
                    className="flex pt-[0.3rem] pb-[0.5rem] pr-1 w-[8%] cursor-pointer"
                    onClick={() => onRemoveRow(data.id)}
                    role="button"
                  >
                    <img
                      src={deleteIcon}
                      className="h-5 w-5 m-auto"
                      alt="Delete"
                    />
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
        <Button
          variant="secondary"
          className="bg-none border-none text-[#4956E4] text-sm px-5 py-4 sticky left-3 bottom-3 m-[10px]"
          onClick={addRow}
        >
          Add +
        </Button>
      </div>
      <div className="flex w-full justify-between py-6 gap-4">
        <DocumentReviewButton
          id="1"
          initialLabel="Approve"
          loadingLabel="Loading..."
          successLabel="Approved"
          colorClass="border-[1px] rounded-md text-[#20785C] border-[#20785C] h-10 w-1/3"
          successColorClass="border-[1px] rounded-md bg-[#E5F9F4] text-[#20785C] border-[#20785C] h-10 w-1/3"
          showIcons={false}
          icon={approvedIcon}
          onClick={() => submitDocument('Approve')}
          disabled={disableOnsubmit}
        />
        <DocumentReviewButton
          id="2"
          initialLabel="Reject"
          loadingLabel="Loading..."
          successLabel="Rejected"
          colorClass="border-[1px] rounded-md text-[#CF0A0A] border-[#CF0A0A] h-10 w-1/3"
          successColorClass="border-[1px] rounded-md text-[#CF0A0A] border-[#CF0A0A] h-10 w-1/3"
          onClick={openRejectionModal}
          showIcons={false}
          disabled={disableOnsubmit}
        />
        <DocumentReviewButton
        id="3"
        initialLabel="Escalate"
        loadingLabel="Loading..."
        successLabel="Escalated"
        colorClass="border-[1px] rounded-md text-[#495AE4] border-[#495AE4] h-10 w-1/3"
        successColorClass="border-[1px] rounded-md bg-[#F0F1FF] text-[#3F51E3] border-[#495AE4] h-10 w-1/3"
        onClick={openEscalationModal} 
        showIcons={false}
        disabled={disableOnsubmit}
        />
      </div>

      {/* Rejection Modal */}
      <EscalationRejectionModal
        modalConfig={{
          title: 'Reject Document',
          onClose: () => setIsRejectionModalOpen(false),
          isOpen: isRejectionModalOpen,
          handleSubmit: (data: any) => {
            submitDocument('Reject', data);
            setIsRejectionModalOpen(false);
          },
        }}
        reasonDropdownConfig={{
          options: rejectionReason,
          label: 'Select reason for rejection*',
        }}
      />

      {/* Escalation Modal */}
      <EscalationRejectionModal
        modalConfig={{
          title: 'Escalate Document',
          onClose: () => setIsEscalationModalOpen(false),
          isOpen: isEscalationModalOpen,
          handleSubmit: (data: any) => {
            submitDocument('Escalate', data);
            setIsEscalationModalOpen(false);
          },
        }}
         reasonDropdownConfig={{
            options: isSupervisor ? legalEscalationReason : [...escalateReason, ...legalEscalationReason],
            label: 'Select reason for escalation*',
          }}
      />
      <NextDocumentModal
        modalConfig={{
          title: getDocumentStatus(type),
          onClose: () => {
            setShowNextDocumentModal(false);
            window.location.reload();
          },
          isOpen: showNextDocumentModal,
          handleSubmit: () => window.location.reload(),
          handlePause: handlePause,
        }}
      />
      <DeleteModal 
         modalConfig={{
          title: `Are you sure you want delete row?`,
          onClose: () => {
            setShowDeleteModal(false);
          },
          isOpen: showDeleteModal,
          handleSubmit: () => removeRow(removeObservationId),
        }}
      />
    </>
  );
};

export default ValidateForm;
